<template>
  <div>
    <van-button type="primary" @click="toSelectDepartment()"
      >选择科室</van-button
    >
    <van-button type="primary" @click="toSelectDoctor()">选择医生</van-button>
    <van-button type="primary" @click="toPayDetail()">付款详情</van-button>
    <van-button type="primary" @click="toGoPay()">订单支付</van-button>
    <van-button type="primary" @click="toPayList()">门诊缴费</van-button>
    <van-button type="primary" @click="toMap()">来院导航</van-button>
    <van-button type="primary" @click="toDoctorDetail()">医生详情</van-button>
    <van-button type="primary" @click="toDoctorFollowList()"
      >医生关注列表</van-button
    >
    <van-button type="primary" @click="prescription()">处方</van-button>
    <van-button type="primary" @click="login()">登录</van-button>
    <van-button type="primary" @click="toMy()">我的</van-button>
    <van-divider />
    <van-button type="info" @click="make()" style="margin-right: 20px"
      >预约体检</van-button
    >
    <van-button type="info" @click="reportIndex()" style="margin-right: 20px"
      >门诊报告</van-button
    >
    <van-button type="info" @click="patient()">就诊人管理</van-button>
    <van-button type="info" @click="seeadoctor()" style="margin-top: 10px"
      >就诊卡明细</van-button
    >

    <van-cell-group>
      <van-field v-model="value" label="测试" placeholder="请输入号码" />
    </van-cell-group>
    <van-button type="primary" @click="pay()">支付！！！</van-button>
  </div>
</template>

<script>
import { payTest } from '@/api/api'
export default {
  name: 'index',
  data() {
    return {
      value: '',
    }
  },
  created() {},
  mounted() {},
  methods: {
    pay() {
      payTest(this.value).then((res) => {
      })
    },
    toMy() {
      this.$router.push('my')
    },
    toDoctorFollowList() {
      this.$router.push('doctorFollowList')
    },
    toDoctorDetail() {
      this.$router.push('doctorDetail')
    },
    toMap() {
      this.$router.push('mapNavigation')
    },
    toSelectDepartment() {
      this.$router.push('selectDepartment')
    },
    toGoPay() {
      this.$router.push('goPay')
    },
    toSelectDoctor() {
      this.$router.push('selectDoctor')
    },
    toPayDetail() {
      this.$router.push('payDetail')
    },
    toPayList() {
      this.$router.push('payList')
    },
    make() {
      this.$router.push('preventionIndex')
    },
    reportIndex() {
      this.$router.push('reportIndex')
    },
    patient() {
      this.$router.push('patientList')
    },
    seeadoctor() {
      this.$router.push('seeadoctor')
    },
    prescription() {
      this.$router.push('list')
    },
    login() {
      this.$router.push('chufang')
    },
  },
}
</script>

<style scoped></style>
